import ProductAPI from "@api/lol/Product.api";
import type IProduct from "@api/models/IProduct";
import AccountDisplay from "@core-components/accountDisplay/AccountDisplay";
import SSProductCard from "@core-components/product/component/SSProductCard";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useCallback, useEffect, useState } from "react";
import { Trans } from "react-i18next";

export const AppPopularWidget: React.FC = () => {
  const { t } = useAppTranslation("components");
  const [popularProducts, setPopularProducts] = useState<IProduct[]>([]);
  const { lang } = useAppLanguage();

  const loadData = useCallback(() => {
    ProductAPI.getPopularProducts().then(setPopularProducts);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData, lang.currentLanguage]);

  return (
    <AccountDisplay.Carousel
      emoji="Fire"
      label={
        <Trans t={t} i18nKey="popularWidget.title">
          <SSWhiteText> SMURFS </SSWhiteText>
          <SSLoLGradientText>POPULAIRES</SSLoLGradientText>
        </Trans>
      }
      title={t("viewAll")}
      onRegionChange={() => {
        loadData();
      }}
    >
      {popularProducts.map((product) => (
        <SSProductCard
          key={product.id}
          product={product}
          header={t("popularWidget.header")}
        />
      ))}
    </AccountDisplay.Carousel>
  );
};
